import { render, staticRenderFns } from "./addFollow.vue?vue&type=template&id=1f6c0baa&scoped=true&"
import script from "./addFollow.vue?vue&type=script&lang=js&"
export * from "./addFollow.vue?vue&type=script&lang=js&"
import style0 from "./addFollow.vue?vue&type=style&index=0&id=1f6c0baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c0baa",
  null
  
)

export default component.exports